// A page-supplied label for the *current* route's leaf crumb — e.g. a player's
// name on the profile page, or the active category on rankings ("Men"). The
// breadcrumb bar clears this on every navigation; pages set it after their data
// resolves so the trail reads "Home › Players › Gabriel Domingo".
import { ref } from 'vue'

export const breadcrumbLeaf = ref<string | null>(null)

export function setBreadcrumbLeaf(label: string | null): void {
  breadcrumbLeaf.value = label
}
